//import SendLocalKatalkArea from "@/pages/comp/basic/katalk/local_katalk/common/send_local_katalk";
import { useState, useRef, useEffect } from 'react';
import Style from "./css/style.module.css";
import MessageListArea from "./area/msg_list";
import strFunc from '@/lib/lyg/string';

function SendLocalKatalkArea(props: any) {
  let myProps = {
    closePopup: () => { },
    refreshData: (inData: any) => { },
    msg_arr: [],//[{room_name:"",message:""}]
    ...props
  };

  const [msg_arr, set_msg_arr] = useState<any[]>(myProps.msg_arr);
  const [check_idx_arr, set_check_idx_arr] = useState<number[]>([]);

  useEffect(() => {

  }, []);

  const get_checked_msg_arr = () => {
    let checked_msg_arr = check_idx_arr.map((check_idx: number) => {
      return msg_arr[check_idx];
    });
    return checked_msg_arr;
  };

  const go_send_katalk = (inData: any) => {
    let opt_obj = {
      select_msg_arr: msg_arr,
      ...inData
    };
    let select_msg_arr = opt_obj.select_msg_arr;
    if (select_msg_arr.length == 0) {
      alert("전송할 메시지를 선택해주세요.");
      return false;
    }

    for (let i = 0; i < select_msg_arr.length; i++) {
      let msg_row = select_msg_arr[i];
      if (strFunc.is_empty(msg_row.room_name)) {
        alert((i + 1) + "번째 메시지의 방이름을 입력해주세요.");
        return false;
      }
    }

    if (confirm("카톡 메시지를 보내시겠습니까?") == false) {
      return;
    }

    let req_json = {
      is_send_auto: "1",
      is_auto_close: "1",
      msg_arr: select_msg_arr
    };

    let req_json_str = JSON.stringify(req_json);
    req_json_str = encodeURIComponent(req_json_str);
    req_json_str = btoa(req_json_str);//base64
    location.href = "intoyoukatalk://" + req_json_str;
  };

  return (
    <div className={Style.wrap}>
      <MessageListArea
        msg_arr={msg_arr}
        set_msg_arr={set_msg_arr}
        Style={Style}
      ></MessageListArea>
      <div className={Style.btn_area}>
        <button className={Style.send_btn}
          onClick={go_send_katalk}
        >PC카톡 전송</button>
        <button className={Style.download_btn}
          onClick={() => {
            window.open(process.env.REACT_APP_API_URL + "/home/util/local_katalk/down");
          }}
        >PC카톡 전송 다운로드</button>
        <button className='btn btn-dark'
          onClick={() => {
            myProps.closePopup();
          }}
        >닫기</button>
      </div>
    </div>
  );
};
export default SendLocalKatalkArea;